import { Snackbar, Slide, Alert } from '@mui/material';

const CustomSnackBar = ({ open, handleClose, msg, type = 'success' }) => {
    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={open}
            onClose={handleClose}
            TransitionComponent={Slide}
            autoHideDuration={3000}
        >
            <Alert
                onClose={handleClose}
                severity={type}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {msg}
            </Alert>
        </Snackbar>
    );
};

export default CustomSnackBar;
